
/*
 * Action Types
 */
export enum StudentsTypes {
  LIST_STUDENTS_REQUEST = '@students/LIST_STUDENTS_REQUEST',
  LIST_STUDENTS_SUCCESS = '@students/LIST_STUDENTS_SUCCESS',
  LIST_STUDENTS_FAILURE = '@students/LIST_STUDENTS_FAILURE',

  GET_STUDENT_REQUEST = '@students/GET_STUDENT_REQUEST',
  GET_STUDENT_SUCCESS = '@students/GET_STUDENT_SUCCESS',
  GET_STUDENT_FAILURE = '@students/GET_STUDENT_FAILURE',

  CREATE_STUDENT_REQUEST = '@students/CREATE_STUDENT_REQUEST',
  CREATE_STUDENT_SUCCESS = '@students/CREATE_STUDENT_SUCCESS',
  CREATE_STUDENT_FAILURE = '@students/CREATE_STUDENT_FAILURE',

  UPDATE_STUDENT_REQUEST = '@students/UPDATE_STUDENT_REQUEST',
  UPDATE_STUDENT_SUCCESS = '@students/UPDATE_STUDENT_SUCCESS',
  UPDATE_STUDENT_FAILURE = '@students/UPDATE_STUDENT_FAILURE',

  DELETE_STUDENT_REQUEST = '@students/DELETE_STUDENT_REQUEST',
  DELETE_STUDENT_SUCCESS = '@students/DELETE_STUDENT_SUCCESS',
  DELETE_STUDENT_FAILURE = '@students/DELETE_STUDENT_FAILURE',

  CREATE_STUDENTS_REQUEST = '@students/CREATE_STUDENTS_REQUEST',
  CREATE_STUDENTS_SUCCESS = '@students/CREATE_STUDENTS_SUCCESS',
  CREATE_STUDENTS_FAILURE = '@students/CREATE_STUDENTS_FAILURE',

  UPDATE_STUDENTS_REQUEST = '@students/UPDATE_STUDENTS_REQUEST',
  UPDATE_STUDENTS_SUCCESS = '@students/UPDATE_STUDENTS_SUCCESS',
  UPDATE_STUDENTS_FAILURE = '@students/UPDATE_STUDENTS_FAILURE',

  DELETE_STUDENTS_REQUEST = '@students/DELETE_STUDENTS_REQUEST',
  DELETE_STUDENTS_SUCCESS = '@students/DELETE_STUDENTS_SUCCESS',
  DELETE_STUDENTS_FAILURE = '@students/DELETE_STUDENTS_FAILURE',

  CHECK_STUDENTS_REQUEST = '@students/CHECK_STUDENTS_REQUEST',
  CHECK_STUDENTS_SUCCESS = '@students/CHECK_STUDENTS_SUCCESS',
  CHECK_STUDENTS_FAILURE = '@students/CHECK_STUDENTS_FAILURE',
}

/*
 * Data types
 */
export interface TimePeriodsInterface {
  id: string;
  title: string;
  start: Date | null;
  end: Date | null;
  schoolId: string;
  custom: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface UserStudentInterface {
  birthdate: string | null;
  birthplace: string | null;
  createdAt: string;
  deleted: boolean;
  email: string;
  id: string;
  name: string;
  nickname: string | null;
  obs: string | null;
  phone: string;
  photoUrl: string | null;
  sex: string | null;
  shortId: string;
  updatedAt: string;
  UserDocuments?: any[];
}

export interface StudentInterface {
  id: string;
  name: string;
  email: string;
  document: string;
  phone: string;
  photoUrl: string;
  createdAt: string;
  updatedAt: string;
  schoolId?: string;
  SchoolPeriod?: TimePeriodsInterface[];
  SchoolTiming?: TimePeriodsInterface[];
  User?: UserStudentInterface;
  schoolCourseId: string;
  selected?: boolean;
}

export interface StudentsUsersInterface {
  name: string;
  document: string;
  value?: string;
}

/*
 * State type
 */
export interface StudentsState {
  readonly studentsList: StudentInterface[];
  readonly studentsCheckUsersList: StudentsUsersInterface[];
  readonly studentData: StudentInterface;
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
